import React from 'react';
import { TimePicker, Button } from 'antd';
import { shortTime } from 'util/DateFormatter.jsx';

class TableTimePicker extends React.Component {
  state = {
    isOpen: false,
  };

  openTimepicker = (status) => {
    this.setState({ isOpen: status });
  }

  closeTimepicker = () => {
    this.setState({ isOpen: false });
  }

  render() {
    return (
      <TimePicker
        {...this.props}
        format={shortTime}
        minuteStep={15}
        allowClear={false}
        placeholder="Ora"
        open={this.state.isOpen}
        onOpenChange={this.openTimepicker}
        addon={() => (
          <Button size="small" type="primary" onClick={this.closeTimepicker} block>
            OK
          </Button>
        )}
      />
    );
  }
}

export default TableTimePicker;
